"use client";

import {createContext, JSX, ReactNode, useContext} from "react";

import {defaultDevice, DeviceInfo} from "@/shared/utils/device/type";

const DeviceContext = createContext<DeviceInfo>(defaultDevice);

interface DeviceProviderProps {
    children: ReactNode;
    device: DeviceInfo;
}

export function DeviceProvider({children, device}: DeviceProviderProps): JSX.Element {
    return <DeviceContext.Provider value={device}>{children}</DeviceContext.Provider>;
}

export function useDevice(): DeviceInfo {
    return useContext(DeviceContext);
}
